 var macuriwebmac = function() {
  var body = $('body'),
   getId = null, //-------> variable vacia
   isMobile = !1, //-------> variable false
   urlPathname = window.location.pathname, //---> ruta y el nombre de archivo de la página actual
   // domainurl = window.location.hostname,//--->tambien (host) ruta del dominio
    domainurl = 'https://www.nonalicoreria.store/';
   //domainurl = 'http://localhost/moran/public';
   //domainurl = 'http://localhost/moran/public'; 


  Toptitop = function() {
    if((/windows phone/i.test(navigator.userAgent)) || (/android/i.test(navigator.userAgent)) ||
     (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream)) {
     isMobile = !0; //---->se convierte en true
    };
    fn.documentAjax();
    fn.documentOnload();
    fn.documentReady();
   },
   fn = {
    documentAjax: function() {
     $(document).ajaxStop(function() {
      console.log("ayax deteniendo")
     });
    },
    documentOnload: function() {
     $(window).on('load', function() {});
    },
    documentReady: function() {
     fn.otros()
     fn.modalpopupmapa()
     fn.btnsociales()
     fn.scrollHome()
    },
    modalpopupmapa:function(){//---> VIDEO -PLANES    
                   //-----> Modal de video plan
                    $(".car_add").click(function(event) {
                      event.preventDefault()
                        showPopup( )
                    }); 
                    function showPopup(){ //--> Metodo Modal
                      $('#modalPed').removeClass('contmod-efectsalir');
                      $('#modalPed').addClass('contmod-efect');
                      $('.body_m').addClass('body_m_efect');
                    }

                    $(".btn-close-popup").click(function(event){ //--->Close Modal 
                      event.preventDefault()
                      $('#modalPed').addClass('contmod-efectsalir');
                      $('.body_m').removeClass('body_m_efect');
                    });
                    $("#btncerrar").click(function(event) {   //--->Close Modal BTN 
                      event.preventDefault()
                      $('#modalPed').addClass('contmod-efectsalir');
                      $('.body_m').removeClass('body_m_efect');
                    });
    },
    otros: function() { //------> OTROS Elementos
     // Si no hay nada en el carrito 
     if(sessionStorage.getItem('cart') === null) {
      $(".filter__item").replaceWith();
      $(".datos").replaceWith();
     }
     //-----> SELECT 2 CONFIG    
     $('.select-inputs').select2({
      language: {
       noResults: function() {
        return "No hay resultado";
       },
       searching: function() {
        return "Buscando..";
       }
      }
     });
     $('.select-inputscuen').select2({
      language: {
       noResults: function() {
        return "No hay resultado";
       },
       searching: function() {
        return "Buscando..";
       }
      },
      placeholder: "Documentos",
     });
     $('.select-inputlib').select2({
       language: {
       noResults: function() {
        return "No hay resultado";
       },
       searching: function() {
        return "Buscando..";
       }
      },
      placeholder: "Documento",
     });
     $('.select-resp').select2({
       language: {
       noResults: function() {
        return "No hay resultado";
       },
       searching: function() {
        return "Buscando..";
       }
      } ,
      placeholder:"Tipo de respuesta (¿Dónde espera recibir la respuesta?)"
     });
     $('.select-quej').select2({
       language: {
       noResults: function() {
        return "No hay resultado";
       },
       searching: function() {
        return "Buscando..";
       }
      } ,
      placeholder:"Tipo "
     });
     //onchanges select Primero - Segundo
     $("#select-project").on('change', onSelectProyectChange)
     $("#select-level").on('change', onSelectCostoEnvio)
     $("#selectipodoc").on('change', onSelectTipodoc)
     $("#selectipodocd").on('change', onSelectTipodocd)
     $("#sel_tdoc").on('change', onSelectTdoc) 
     $("#sel_resp").on('change', onSelectresp) 
     $("#sel_tipo").on('change', onSelectTipo) 

     //Libro de raclamaciones distritos
     $("#select-provin").on('change', onSelectProvinChange)

     function onSelectTipodoc() {
      $("#selectipodoc-error").hide('slow/400/fast', function() {});
     }

     function onSelectTipodocd() {

      $("#selectipodocd-error").hide('slow/400/fast', function() {});
     }
     function onSelectTdoc() {

      $("#sel_tdoc-error").hide('slow/400/fast', function() {});
     }
      function onSelectresp() {

      $("#sel_resp-error").hide('slow/400/fast', function() {});
     }
     function onSelectTipo() {

      $("#sel_tipo-error").hide('slow/400/fast', function() {});
     }


     function onSelectProyectChange() {
      $('#select-level').removeAttr('disabled');
      $("#select-project-error").hide('slow/400/fast', function() {});
      let proyect_id = $(this).val()
      if(proyect_id !== '') {
        // 1. LLENAMOS EL CAMPO TEXT DE NOMBRE DE DEPARTAMENTO
        let nomdepart = $("#select-project option:selected").text(); //Distrito
        $("#nom_dep").val(nomdepart)
        //  2. ajax
        let _token = $('input[name="_token"]').val()
        $.ajax({
         url: domainurl + '/select/' + proyect_id + '/niveles/',
         type: 'GET',
        })
        .done(function(data) {
         let html_select = '<option class="text-center colorgris" value="">--  Seleccione  --</option>'
         for(var i = 0; i < data.length; ++i) {
          var matador = data[i].idimage
          if(data[i].costoenvio && data[i].name) {
           html_select += '<option class="text-center" value="' + data[i].costoenvio + '">' + data[i].name + '</option>'
          }
         }
         $('#select-level').html(html_select)
        })
        .fail(function() {
         console.log("error");
        })
      }
     }

     function onSelectCostoEnvio() {
      $("#select-level-error").hide('slow'); //---> Oculta alerta distrito 
      let distrito_id = $(this).val()
      let sesioncartjq = '[' + JSON.parse(sessionStorage.getItem('cart')) + ']';
      let descuentSol = $("#valdesccod").html().split('S/.')[1]; //--> GET descuento X cupon
      let descuentPor = $("#valdesccod").html().split('-')[1]; //--> GET descuento X cupon
      let dnival = $("#dni").val();
      let codval = $("#promcode").val();
      let distrito = $("#select-level option:selected").text(); //Distrito
      //console.log(sesioncartjq);
      //console.log($("#macurip").val())
      // traemos el precio del costo de envio en: distrito_id

      if(distrito_id !== '' && distrito_id !== null) { //--> Opcion Disitrito lleno

        //LLENAMOS CAMPO DEL NOMBRE DE DISTRITO
        let nomdistri = $("#select-level option:selected").text(); //Distrito
        $("#nom_dis").val(nomdistri)
 
        console.log("se crea la sesion del car en el backend")

       let _token = $('input[name="_token"]').val()
       $.ajax({
         url: domainurl + '/valsesi',
         type: 'POST',
         data: {
          _token: _token,
          sesijq: sesioncartjq,
          descuentPor: descuentPor,
          codval: codval,
          dnival: dnival,
          distrito:distrito,
         },
         beforeSend: function() {
          $(".conloadercheck").addClass('loadz')
         },
        })
        .done(function(data) {
           var areglodata = JSON.parse(data);
           console.log(areglodata)
           $("#id_dis").val(areglodata.id_dis)
         $(".conloadercheck").removeClass('loadz')

         //---> SETEAS Costoenvio X distrito
         $("#costenvi").fadeToggle("slow").html("S/. " + distrito_id)
         $("#costenvi").fadeToggle("slow").html("S/. " + distrito_id)
         let subtot = $("#subtot").html() //---> GET el subtotal

         //DESCUENTO EN SOLES  VALIDAMOS PARA FRONTEND
         if(descuentSol) {
          //console.log("existe el cupon en soles")
          //--->Operacion X total Pedido => descuento soles
          let totalP = parseFloat(subtot.split('S/.')[1]) + parseFloat(distrito_id) - parseFloat(descuentSol);
          //---> SETEAS el total del pedido
          $("#totcheckfin").fadeToggle("slow").html('S/. ' + totalP.toFixed(2))
          $("#totcheckfin").fadeToggle("slow").html('S/. ' + totalP.toFixed(2))
          $("#toto").val(totalP.toFixed(2))
           //DESCEUNTO EN %
         } else {
          //--->GET xPORCENTAJE
          let desPorc = (descuentPor.substring(0, descuentPor.length - 1)) / 100;
          //--->Operacion Porcentual del (Subtot + Envio)
          let descuenX = ((parseFloat(subtot.split('S/.')[1]) + parseFloat(distrito_id)) * parseFloat(desPorc)).toFixed(2)
          console.log(descuenX)
           //--->Operacion X total Pedido => descuento soles
          let totalP = parseFloat(subtot.split('S/.')[1]) + parseFloat(distrito_id) - parseFloat(descuenX);
          //---> SETEAS el total del pedido
          $("#totcheckfin").fadeToggle("slow").html('S/. ' + totalP.toFixed(2))
          $("#totcheckfin").fadeToggle("slow").html('S/. ' + totalP.toFixed(2))
          $("#toto").val(totalP.toFixed(2))
         }
         //--->envias name del select al input hidden
         $('#hidendistri').val($("#select-level option:selected").text());
        })
        .fail(function() {
         Swal.fire({
          icon: 'error',
          title: "No se pudo Procesar  !!!",
          text: "Vuelva a intentar",
          confirmButtonText: "Aceptar",
         })
        })
      }
     }

     function onSelectProvinChange() {
      $('#select-distri').removeAttr('disabled');
      let subselctlevel = $("#select-sublevel option:selected").val()
      let proyect_id = $(this).val()
      if(proyect_id !== '') {
       //ajax
       let _token = $('input[name="_token"]').val()
       $.ajax({
         url: domainurl + '/select/' + proyect_id + '/niveles/',
         type: 'GET',
        })
        .done(function(data) {
         //console.log(data)
         let html_select = '<option class="text-center colorgris" value="">--  Seleccione  --</option>'
         for(var i = 0; i < data.length; ++i) {
          if(data[i].costoenvio && data[i].name) {
           html_select += '<option class="text-center" value="' + data[i].id + '">' + data[i].name + '</option>'
          }
         }
         $('#select-distri').html(html_select)
        })
        .fail(function() {
         console.log("error");
        })
      }
     }

     $("#corazo").click(function(event) {
      event.preventDefault()
      $("#heart").toggleClass('#FF0000');
     });

     //---->Tienda Categoria Toogle
     $('.sub-menu-cat ul').hide();
     $(".sub-menu-cat .afirst").click(function(e) {
      e.preventDefault()
      $(this).parent(".sub-menu-cat").children("ul").slideToggle("100");
      $(this).find(".right").toggleClass("fa-caret-up fa-caret-down");
     });

     $('.header-content .nav-list ul li').click(function() {
      $(this).addClass('selected');
      $(this).siblings().removeClass('selected');
     });
     $('.sub-menu_nav ol').hide();
     $(".sub-menu_nav .afirst").click(function(e) {
      e.preventDefault()
      $(this).parent(".sub-menu_nav").children("ol").slideToggle("100");
     });
     //-----> Validacion Previa    
     $("#nomr").bind('keypress', function(event) { //--->NomCtas
      var regex = new RegExp("^[a-zA-ZÑñ ]+$");
      var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
      if(!regex.test(key)) {
       event.preventDefault();
       return false;
      }
      if(this.value.length === 20) {
       return false;
      }
     });
     $(".nom").bind('keypress', function(event) { //--->NomCtas
      var regex = new RegExp("^[a-zA-ZÑñ ]+$");
      var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
      if(!regex.test(key)) {
       event.preventDefault();
       return false;
      }
      if(this.value.length === 25) {
       return false;
      }
     });
     $("#passr").bind('keypress', function(event) { //--->Passwor
      if(this.value.length === 10) {
       return false;
      }
     });
     $("#emailr").bind('keypress', function(event) { //--->Email 
      if(this.value.length === 35) {
       return false;
      }
     });
     $(".emailc").bind('keypress', function(event) { //--->Email 
      if(this.value.length === 35) {
       return false;
      }
     });
     $("#passlogin").bind('keypress', function(event) { //--->Passwor
      if(this.value.length === 10) {
       return false;
      }
     });
     $("#emailogin").bind('keypress', function(event) { //--->Email 
      if(this.value.length === 35) {
       return false;
      }
     });
     $(".celr").bind('keypress', function(event) { //--->Telefo
      var regex = new RegExp("^[0-9]+$");
      var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
      if(!regex.test(key)) {
       event.preventDefault();
       return false;
      }
      if(event.which < 48 || event.which > 57 || this.value.length === 12) {
       return false;
      }
     });
      $(".mont_rec").bind('keypress', function(event) {  
        if ($(this).val().indexOf('.') != -1 && $(this).val().substring($(this).val().indexOf('.'), $(this).val().indexOf('.').length).length > 2){
          return false;
        }
      });
      $(".mont_rec_2").bind('keypress', function(event) { //--->Telefo
      if(this.value.length === 12) {
       return false;
      }
     });
     $("#celc").bind('keypress', function(event) { //--->Telefo
      var regex = new RegExp("^[0-9]+$");
      var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
      if(!regex.test(key)) {
       event.preventDefault();
       return false;
      }
      if(event.which < 48 || event.which > 57 || this.value.length === 12) {
       return false;
      }
     });
 
     $(".numdoc_").bind('keypress', function(event) { //---->Dni   
      var regex = new RegExp("^[0-9]+$");
      var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
      if(!regex.test(key)) {
       event.preventDefault();
       return false;
      }
      if(event.which < 48 || event.which > 57 || this.value.length === 20) {
       return false;
      }
     });     

     $("#lastname").bind('keypress', function(event) { //--->Apelli
      var regex = new RegExp("^[a-zA-ZÑñ ]+$");
      var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
      if(!regex.test(key)) {
       event.preventDefault();
       return false;
      }
      if(this.value.length === 25) {
       return false;
      }
     });
     $(".lastname").bind('keypress', function(event) { //--->Apelli
      var regex = new RegExp("^[a-zA-ZÑñ ]+$");
      var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
      if(!regex.test(key)) {
       event.preventDefault();
       return false;
      }
      if(this.value.length === 25) {
       return false;
      }
     });
     $("#nomceunt").bind('keypress', function(event) { //--->Nombre
      var regex = new RegExp("^[a-zA-ZÑñ ]+$");
      var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
      if(!regex.test(key)) {
       event.preventDefault();
       return false;
      }
      if(this.value.length === 60) {
       return false;
      }
     });
     $("#direcc").bind('keypress', function(event) { //--->Direcc
      var regex = new RegExp("^[a-zA-ZÑñ ]+$");
      var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
      if(!regex.test(key)) {
       event.preventDefault();
       return false;
      }
      if(this.value.length === 100) {
       return false;
      }
     });
     $("#direcc2").bind('keypress', function(event) { //--->Direc2
      var regex = new RegExp("^[a-zA-ZÑñ ]+$");
      var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
      if(!regex.test(key)) {
       event.preventDefault();
       return false;
      }
      if(this.value.length === 100) {
       return false;
      }
     });

     $("#toto").bind('keypress', function(event) { //---->total 
      if($(this).val().indexOf('.') != -1 && $(this).val().substring($(this).val().indexOf('.'), $(this).val().indexOf('.').length).length > 2) {
       return false;
      }
     });


     $("#mensaj").bind('keypress', function(event) {
      if(this.value.length === 240) {
       return false;
      }
     });
     $(".cant").bind('keypress', function(event) {
      var regex = new RegExp("^[0-9]+$");
      var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
      if(!regex.test(key)) {
       event.preventDefault();
       return false;
      }
      if(event.which < 48 || event.which > 57 || this.value.length === 4) {
       return false;
      }
     });
     $("#montor").bind('keypress', function(event) { //--->LibroReclamación Monto-Registrado
      if(this.value.length === 20) {
       return false;
      }
     });
     $("#descpro").bind('keypress', function(event) { //--->LibroReclamación Descri-Producto 
      if(this.value.length === 150) {
       return false;
      }
     });
     $("#detrecla").bind('keypress', function(event) { //--->LibroReclamación Detalle-Reclamo 
      if(this.value.length === 150) {
       return false;
      }
     });
     $("#pedrecla").bind('keypress', function(event) { //--->LibroReclamación Pedido-Reclamo  
      if(this.value.length === 150) {
       return false;
      }
     });
     $("#descr").bind('keypress', function(event) { //--->LibroReclamación Descripcion Ped 
      if(this.value.length === 150) {
       return false;
      }
     });
     //-----> ALERTIFY CONFIG      
     if($(".alert").length > 0) {
      alertify.alert()
       .setting({
        'title': 'Se ha producido un error : ',
        'label': 'ok',
        'message': $('.alert').html(),
        'onok': function() {
         alertify.error('😔 Vuelva a intentar !!!');
        }
       }).show();
     }
     if($(".suceess").length > 0) {
      alertify.alert()
       .setting({
        'title': 'Proceso realizado con exito !!!',
        'label': 'ok',
        'message': $('.suceess').html(),
        'onok': function() {
         alertify.success($('#subitisucess').html());
         sessionStorage.removeItem('cart');
         $(".clearfix").html(`<li class="clearfix" id="licart">
     <h5>Sin ningún producto</h5> </li>`)
         $(".main-color-text").html('00,00')
         $("#pricebtnca").html('S/.  00,00')
         $(".count-item").html('0 item')
         $(".shopping-cart-badge").html('0')
        }
       }).show()
     }
     //-----> TOOLTIP CONFIG       

     $('[data-toggle="tooltip"]').tooltip()
      //----> METODO JQUERYVALIDATE 
     jQuery.validator.addMethod("lettersonly", function(value, element) {
      return this.optional(element) || /^[a-zA-Z ]+$/i.test(value);
     }, "Solo letras por favor");
     jQuery.validator.addMethod("noSpace", function(value, element) {
      return value == "" || value.trim().length != 0;
     }, "No dejar espacios vacios");

     function validar(value) { //---> metodo para valida DNI
      var ex_regular_dni;
      ex_regular_dni = /^\d{12}(?:[-\s]\d{8})?$/;
      if(ex_regular_dni.test(value) == true) {
       return true;
      } else {
       return false;
      }
     }
     $.validator.addMethod('dnivalida', function(value, element) {

      return this.optional(element) || validar(value);
     }, "Dni invalido");
    },
    scrollHome: function() { //-----> SCROL Home       
     $('a[href*="#"]:not([href="#"])').click(function() {
      if(location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
       var target = $(this.hash);
       target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
       if(target.length) {
        $('html, body').animate({
         scrollTop: target.offset().top -= 50
        }, 1000, 'easeOutBounce');
        return false;
       }
      }
     });
     $.scrollUp({ //-----> Scrollup Home 
      // topDistance: '1500', // Distance from top before showing element
      scrollText: "",
      scrollSpeed: 1000,
      easingType: "easeOutBounce"
     });
    },
    btnsociales: function() { //------> BTN SOCIAL MEDIA
     /*************botonos sociales***/
     if($(".social-button").length > 0) {
      var social_open = false;
      window.addEventListener("load", () => {
       const menu = document.querySelector(".social-button");
       let imglogo = document.querySelector("#macuimg")
       menu.addEventListener("click", () => {
        const icon = document.querySelector("#social-icon");
        if(social_open == true) {
         social_open = false;

         menu.title = menu.title.replace(/hide/, "expand");
         menu.classList.remove("social-button-open");
         icon.classList.remove("fa-times");
         imglogo.style.visibility = 'visible'


         var menu_point = document.querySelectorAll(".social-point");
         for(let i = 0; i < menu_point.length; i++) {
          menu_point[i].classList.remove("social-point-open");
          setTimeout(function() {
           menu_point[i].hidden = true;
          }, 800);
         }
        } else {
         social_open = true;

         menu.title = menu.title.replace(/expand/, "hide");
         menu.classList.add("social-button-open");
         imglogo.style.visibility = 'hidden'
         icon.classList.add("fa-times");

         var menu_point = document.querySelectorAll(".social-point");
         for(let i = 0; i < menu_point.length; i++) {
          menu_point[i].hidden = false;
          setTimeout(function() {
           menu_point[i].classList.add("social-point-open");
          }, 200);
         }
        }
       });
      });
     }
    },

   }
  Toptitop()
 }(jQuery, window);